import React, { useEffect, useState } from 'react';
import farnell from "src/assets/images/farnell-logo-xl.png";
import element14logo from "src/assets/images/element14-logo-xl.png";
import System from 'src/helper/system';
import { useProductStore } from 'src/hooks/product';
import AxiosIndicatorRunTimeLoader from '../Global/AxiosIndicatorRunTimeLoader';
import yellowAlert from "src/assets/images/yellow-alert.png";

const FarnelElementStockPopup = (props) => {
    const { data, SetStatus } = props;
    const { translation: t } = System;
    const [{ }, { get_farnel_element_stock }, { }] = useProductStore();
    const [farnellData, setFarnellData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            const res = await get_farnel_element_stock({ erpPartNumber: data.erpPartNumber, countryCode: data.countryCode });
            if (res) {
                setFarnellData(res.Data?.FarnellAPIResponseModel);
            }
            setLoading(false);
        };

        fetchData();
    }, []);

    const PriceTableForFarnell = ({ single_product_pricing_list, linesToDisplay = 3 }) => {
        const [expanded, setExpanded] = useState(false);
        const linesToShow = expanded ? single_product_pricing_list.length : linesToDisplay;

        const pricingRows = single_product_pricing_list.map((v, i) => {
            const visibility = v.From > 0 ? 'visible' : 'hidden';
            const price = System.getFormatNumber({ amount: Number(v.Cost), currency: window.mct });

            return (
                <div className="bs5 row mx-0" key={i} style={{ display: i < linesToShow ? 'flex' : 'none' }}>
                    <div className="ps-0 col-6 font-12" style={{ visibility }}>
                        <span>{v.From + "+"}</span>
                    </div>
                    <div className="pe-0 col-6 text-end font-12">
                        <span>{price}</span>
                    </div>
                </div>
            );
        });

        return (
            <>
                <div className="price-table-list">
                    {pricingRows}
                </div>
                {single_product_pricing_list.length > linesToDisplay && (
                    <a className='text-blue2 d-flex mt-1' href={void (0)}
                        onClick={() => setExpanded(prev => !prev)}
                    >
                        <span className="font-bold font-12">{expanded ? 'Less Pricing' : 'More Pricing'}</span>
                        <i className={`fa fa-angle-${expanded ? 'up' : 'down'} font-bold font-16 ms-1`}></i>
                    </a>
                )}
            </>
        );
    };
    const urlRedirection = (id) => {
        return data.isEligibleForElement
            ? `https://au.element14.com/${id}?cmp=ASIA-Avnet-PLP-cross-sell`
            : `https://export.farnell.com/${id}?cmp=EU-Avnet-PLP-cross-sell`
    };
    return (
        <div>
            <div className="avnet-modal modal-700">
                <div className="avnet-modal-inner">
                    <button type="button" className="close" onClick={() => SetStatus(false)}>{t('x')}</button>
                    <div className="modal-header justify-content-center">
                        <h2 className="pcn-modal-heading font-24">
                            {t('availableFrom')} {data.isEligibleForElement ? t('element') : t('farnell')} ({t('anAvnetCompany')})
                        </h2>
                    </div>
                    {loading ? (
                        <AxiosIndicatorRunTimeLoader />
                    ) : (
                        <>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <p className="mb-2">{t('checkBelowForAvailability')}</p>
                                        <img src={data.isEligibleForElement ? element14logo : farnell} className="img-fluid" />
                                    </div>
                                    {farnellData?.Products?.length ?
                                        <><div className="col-md-12 mb-3">
                                            <table className="bs5 table table-bordered mt-4">
                                                <thead>
                                                    <tr className="bg-grey2">
                                                        <th>{t('PARTNUMBER')}</th>
                                                        <th>{t('price')}</th>
                                                        <th className='text-uppercase'>{t('availability')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {farnellData?.Products.map((x, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <a href={urlRedirection(x.Sku)} className="text-blue cursor-pointer" target="_blank">
                                                                    <b>{x?.TranslatedManufacturerPartNumber}</b>
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <PriceTableForFarnell single_product_pricing_list={x?.Prices} />
                                                            </td>
                                                            <td>
                                                                <div className="">
                                                                    <div className="d-flex justify-content-between">
                                                                        <div className="additional-title">Partner Stock</div>
                                                                        <div className="lead-time-digit text-end ms-1">
                                                                            {x?.Stock?.Level}<br />
                                                                            {x?.Stock?.ShipsInDays}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                            <p className="mb-2 ms-3">
                                                {data.isEligibleForElement ? t('element') : t('farnell')} {t('termsConditionsApply')}
                                            </p>
                                        </>
                                        :
                                        <div className='ms-3 me-3'>
                                            <div className="col-lg-12 p-0  alert mb-0 alert-alert mb-0 alert-danger mt-3">
                                                {t('DuetoAPIConnectivityIssueweAreNotAbletoFetchData')}
                                                <img className="ms-auto" src={yellowAlert} />
                                            </div>
                                        </div>
                                    }
                                </div>

                            </div>
                            <div className="modal-footer justify-content-center">
                                <div className="modal-footer-actions">
                                    <button type="button" className="bs5 btn btn-secondary btn-sm w145" onClick={() => SetStatus(false)}>{t('cancel')}</button>
                                    {farnellData?.Products.length ?
                                        <a href={urlRedirection(farnellData?.Products.length == 1 ? farnellData?.Products[0]?.Sku : farnellData?.Products[0]?.TranslatedManufacturerPartNumber)} className="bs5 btn btn-primary btn-sm cursor-pointer" target="_blank">
                                            {t('viewOn')} {data.isEligibleForElement ? t('element') : t('farnell')}
                                        </a>
                                        :
                                        <button className="bs5 btn btn-primary btn-sm" disabled>{t('viewOn')} {data.isEligibleForElement ? t('element') : t('farnell')}</button>
                                    }
                                </div>
                            </div></>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FarnelElementStockPopup;
